import * as type from "../types";

const initialIndividualWorkingHours = {
  godzina_start: 0,
  godzina_koniec: 0,
  godziny_indywidualne: false
};

export const initialZones = {
  pozycja: {},
  lista_rejon: []
};

const initialInsuranceDate = {
  data_ubezpieczenia: 0,
  ost_data_ubezpieczenia: 0
};

const initialInspections = {
  technical: {
    data_przegladu: 0,
    ost_data_przegladu: 0
  },
  service: {
    przeglad_co: 0,
    przeglad_data: 0,
    informacja_przed: 0,
    informacja_po: 0,
    ostatni_przeglad: 0
  },
  history: {
    przeglady_serwisowe: []
  }
};

const initialContractedMileage = {
  aktualna_data: 0,
  aktualny_przebieg: 0,
  dystans: 0,
  ilosc_dni_kontraktu: 0,
  koniec_kontraktu: 0,
  ktory_dzien_kontraktu: 0,
  nadprzebieg: false,
  planowany_przebieg_dzienny: 0,
  poczatek_kontraktu: 0,
  prawidlowy_przebieg: 0,
  przekroczenie_przebiegu: 0,
  zakontraktowany_przebieg: 0
};

const initialReports = {
  email_domyslny: null,
  email_prywatny: null,
  kwartalny: {
    domyslny: false,
    prywatny: false
  },
  miesieczny: {
    domyslny: false,
    prywatny: false
  },
  tygodniowy: {
    domyslny: false,
    prywatny: false
  },
  opony: {
    domyslny: false,
    prywatny: false
  },
  ubezpieczenie: {
    domyslny: false,
    prywatny: false
  },
  przeglad_serwis: {
    domyslny: false,
    prywatny: false
  },
  przeglad_techniczny: {
    domyslny: false,
    prywatny: false
  }
};

const initialSettings = {
  haslo: "",
  pin: "0000",
  telefon_urzadzenia: "",
  predkosc_max: "",
  telefon_alarmowy1: {
    aktywny: false,
    numer: "",
    stan_akumulatora: false,
    wlamanie: false
  },
  telefon_alarmowy2: {
    aktywny: false,
    numer: "",
    stan_akumulatora: false,
    wlamanie: false
  },
  monitorowanie: false,
};

const initialSms = {
  blokada: 0,
  serwis: 0,
  panic: 0,
  lista_sms: []
};

const initialCarEvidence = {
  ewidencja_poczatek: "",
  ewidencja_koniec: ""
};

const initialCarParameters = {
  kierowca: "",
  marka: "",
  model: "",
  opis: "",
  paliwo: "",
  skrzynia: "",
  sr_zuzycie_paliwa: "",
  typ: ""
};


const initialPossibleParameters = {
  marki: [],
  modele: [],
  paliwa: [],
  skrzynie_biegow: [],
  typy_aut: []
};

const initialCarRent = {
  data_do: 0,
  data_od: 0,
  kierowca: {
    data_prawa: 0,
    imie: "",
    kod: "",
    miasto: "",
    organ: "",
    pesel: "",
    prawo: "",
    telefon: "",
    ulica: ""
  },
  kierowca_dodatkowy: {
    data_prawa: 0,
    imie: "",
    kod: "",
    miasto: "",
    organ: "",
    pesel: "",
    prawo: "",
    telefon: "",
    ulica: ""
  },
  klient: {
    dowod: "",
    email: "",
    kod: "",
    miasto: "",
    nazwa: "",
    nip: "",
    pesel: "",
    regon: "",
    rodzaj: 0,
    telefon: "",
    ulica: ""
  },
  limitkm: 0,
  limitkm_rodzaj: 0,
  limitkm_rodzaj_lista: [],
  nr_rej_w_naprawie: "",
  umowa_nr: 0,
  umowa_mc: 0,
  umowa_rok: 0,
  nr_zlecenia: "",
  opis: "",
  ryczalt: "",
  ryczalt_rodzaj: 0,
  ryczalt_rodzaj_lista: [],
  stawka_pow_limit: "",
  wynajem_id: 0
};

const initialCarPool = {
  cel_podrozy: "",
  data_do: 0,
  data_od: 0,
  kierowca_id: 0,
  kierowca_nazwa: "",
  rozpoczal: "",
  wynajem_id: 0,
  zakonczyl: ""
};

const initialCarDamage = [
  { nazwa: "bagaznik", obraz_id: "", opis: "", uszkodzony: false },
  { nazwa: "blotnik_przod_lewy", obraz_id: "", opis: "", uszkodzony: false },
  { nazwa: "blotnik_przod_prawy", obraz_id: "", opis: "", uszkodzony: false },
  { nazwa: "blotnik_tyl_lewy", obraz_id: "", opis: "", uszkodzony: false },
  { nazwa: "blotnik_tyl_prawy", obraz_id: "", opis: "", uszkodzony: false },
  { nazwa: "dach", obraz_id: "", opis: "", uszkodzony: false },
  { nazwa: "drzwi_przod_lewy", obraz_id: "", opis: "", uszkodzony: false },
  { nazwa: "drzwi_przod_prawy", obraz_id: "", opis: "", uszkodzony: false },
  { nazwa: "drzwi_tyl_lewy", obraz_id: "", opis: "", uszkodzony: false },
  { nazwa: "drzwi_tyl_prawy", obraz_id: "", opis: "", uszkodzony: false },
  { nazwa: "kolo_przod_lewy", obraz_id: "", opis: "", uszkodzony: false },
  { nazwa: "kolo_przod_prawy", obraz_id: "", opis: "", uszkodzony: false },
  { nazwa: "kolo_tyl_lewy", obraz_id: "", opis: "", uszkodzony: false },
  { nazwa: "kolo_tyl_prawy", obraz_id: "", opis: "", uszkodzony: false },
  { nazwa: "maska", obraz_id: "", opis: "", uszkodzony: false },
  { nazwa: "slupek_lewy", obraz_id: "", opis: "", uszkodzony: false },
  { nazwa: "slupek_prawy", obraz_id: "", opis: "", uszkodzony: false },
  { nazwa: "swiatlo_przod", obraz_id: "", opis: "", uszkodzony: false },
  { nazwa: "swiatlo_tyl", obraz_id: "", opis: "", uszkodzony: false },
  { nazwa: "szyba_przod", obraz_id: "", opis: "", uszkodzony: false },
  { nazwa: "szyba_tyl", obraz_id: "", opis: "", uszkodzony: false },
  { nazwa: "zderzak_przod", obraz_id: "", opis: "", uszkodzony: false },
  { nazwa: "zderzak_tyl", obraz_id: "", opis: "", uszkodzony: false },
];

const initialCarDamageImages = [];

const initialCarPricing = {
  cennik_id: -1
};

const initialState = {
  cars: [],
  selectedCar: null,
  zones: initialZones,
  inspection: null,
  individualWorkingHours: initialIndividualWorkingHours,
  insuranceDate: initialInsuranceDate,
  inspections: initialInspections,
  reports: initialReports,
  contractedMileage: initialContractedMileage,
  settings: initialSettings,
  data: [],
  sms: initialSms,
  carParameters: initialCarParameters,
  carEvidence: initialCarEvidence,
  ecoChart: [],
  possibleCarParameters: initialPossibleParameters,
  carRent: initialCarRent,
  carPool: initialCarPool,
  remarks: [],
  changes: [],
  rentList: [],
  carDamage: initialCarDamage,
  carDamageImages: initialCarDamageImages,
  carPricing: initialCarPricing,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.SET_CARS:
      return {
        ...state,
        cars: action.value
      };
    case type.SET_CAR:
      return {
        ...state,
        selectedCar: action.value
      };
    case type.SET_ZONES:
      return {
        ...state,
        zones: action.value
      };
    case type.SET_INDIVIDUAL_WORKING_HOURS:
      return {
        ...state,
        individualWorkingHours: action.value
      };
    case type.SET_INSURANCE_DATE:
      return {
        ...state,
        insuranceDate: action.value
      };
    case type.SET_TECHNICAL_INSPECTIONS:
      return {
        ...state,
        inspections: {
          ...state.inspections,
          technical: action.value
        }
      };
    case type.SET_SERVICE_INSPECTIONS:
      return {
        ...state,
        inspections: {
          ...state.inspections,
          service: action.value
        }
      };
    case type.SET_SERVICE_INSPECTIONS_HISTORY:
      return {
        ...state,
        inspections: {
          ...state.inspections,
          history: action.value.przeglady_serwisowe &&
          action.value.przeglady_serwisowe.length > 0 ?
            action.value : { przeglady_serwisowe: [] }
        }
      };
    case type.SET_REPORTS_AND_NOTIFICATIONS:
      return {
        ...state,
        reports: action.value
      };
    case type.SET_CONTRACTED_MILEAGE:
      return {
        ...state,
        contractedMileage: action.value
      };
    case type.SET_CAR_SETTINGS:
      return {
        ...state,
        settings: action.value
      };
    case type.SET_SMS:
      return {
        ...state,
        sms: action.value
      };
    case type.SET_DATA:
      return {
        ...state,
        data: action.value
      };
    case type.SET_CAR_PARAMETERS:
      return {
        ...state,
        carParameters: action.value
      };
    case type.SET_CAR_EVIDENCE:
      return {
        ...state,
        carEvidence: action.value
      };
    case type.SET_CAR_ECO_CHART:
      return {
        ...state,
        ecoChart: action.value
      };
    case type.SET_POSSIBLE_PARAMETERS:
      return {
        ...state,
        possibleCarParameters: action.value
      };
    case type.SET_CAR_RENT:
      return {
        ...state,
        carRent: action.value
      };
    case type.SET_CAR_POOL:
      return {
        ...state,
        carPool: action.value
      };
    case type.SET_REMARKS:
      return {
        ...state,
        remarks: action.value
      };
    case type.SET_CHANGES:
      return {
        ...state,
        changes: action.value
      };
    case type.SET_RENT_LIST:
      return {
        ...state,
        rentList: action.value
      };
    case type.SET_CAR_DAMAGE:

      return {
        ...state,
        carDamage: action.value
      };
    case type.SET_CAR_DAMAGE_IMAGE:
      // eslint-disable-next-line no-case-declarations
      const tmp = [...state.carDamageImages];
      if (action.value) {
        // eslint-disable-next-line no-case-declarations
        const { obraz_id, obraz_b64 } = action.value;
        // eslint-disable-next-line no-case-declarations
        const idx = tmp.findIndex(item => +item.obraz_id === +obraz_id);

        if (idx !== -1) {
          tmp[idx] = { obraz_id, obraz_b64 };
        } else {
          tmp.push({ obraz_id, obraz_b64 });
        }
      }

      return {
        ...state,
        carDamageImages: [...tmp]
      };
    case type.SET_CAR_PRICING:
      return {
        ...state,
        carPricing: action.value
      };
    default:
      return state;
  }
};
